<template>
    <div class="fixwidth">
        <div class="classify-box overflow_hide">
            <div class="fl">专业大类:</div>
            <div class="fr tags">
                <div class="fr second-box">
                    <ul class="">
						<li @click="chooseCatalog()" ref="all" class="fl font-active">全部</li>
                        <li @click="chooseCatalog(m)"
							class="fl"
							v-for="m in major"
							:key="m.id"
							:class="m.active?'font-active':''">{{m.defaultName}}</li>
                    </ul>
                </div>
            </div>
        </div>

		<div v-if="category.length>0" class="classify-box">
			<div class="fl">课程分类:</div>
			<div class="fr tags">
				<div class="fr second-box">
					<ul class="">
						<li @click="changeCategory(c)"
							class="fl"
							v-for="c in category"
							:key="c.id"
							:class="c.active?'font-active':''">{{c.defaultName}}</li>
					</ul>
				</div>
			</div>
		</div>


		<div class="tabs clearfix">
			<ul>
				<li v-for="r in routers" :key="r.name">
					<a @click="changeClassify(r)"
						:class="r.active?'tabs-active':''">{{r.name}}</a>
				</li>
			</ul>
			<div class="fr" style="line-height: 55px;">
				<el-input style="width:200px" @keyup.enter.native="infoSearch" v-model="searchInfo.andModel.orLike" placeholder="请输入课程名称或主讲人"></el-input>
				<el-button style="display: inline-block;margin: 0 10px" @click="infoSearch">搜索</el-button>
			</div>
		</div>

        <ResourceList
				ref="resourceList"
                :resource="resource"
                :pageSize=searchInfo.pageObject.pageSize
                :size="total"
                @changeCurrent="changeCurrent"
                moduleName="VideoResource"></ResourceList>
    </div>
</template>

<script>
    import ResourceList from '../components/ResourceList'
    import Utils from '../assets/js/Utils'
    export default {
        name: "Resource",
        components:{ResourceList},
        data(){
            return{
                uploadMessage:0,
                dialogFormVisible:false,
                fileList:[],
                sourceType:[],
                searchInfo:{
                    pageObject:{
                        pageSize:8,
                        currentPage:1
					},
                    andModel:{
						isPay:false,
                        orLike:""
					},
                },
                total:0,
                tags:[],
                routers: [],
                resource:[],
                form:{
                    resourceName:"",
                    resourceDescribe:"",
                    pCode:"",
                    dicId:"",
                },
                secondVisible:false,              //tab标签二级菜单是否可见
                secondTags:[],
                major:[],
				category:[]
            }
        },
        created(){
            this.getResource(this.searchInfo);
			this.getVideoClassify();
			this.getRouters();
        },
        methods: {
            getRouters(){
                this.routers = this.common.getChildren(2);
                this.routers.forEach((index)=>{
                    this.$set(index,"active",false);
                });
                this.$set(this.routers[0],"active",true);
            },
			//搜索
            infoSearch(){
                this.searchInfo.pageObject.currentPage = 1;
                this.getResource(this.searchInfo);
                if(this.$refs.resourceList!==undefined){
                    this.$refs.resourceList.exist = false;
                    this.$nextTick(()=>{
                        this.$refs.resourceList.exist = true;
                    });
                }
            },
            /*获取资源*/
            getResource(searchInfo) {
                this.$json("/course/user/page","POST",searchInfo).then(res=>{
                    this.resource = res.data;
                    this.total = res.total;
                })
            },
            getVideoClassify() {             //获取视频分类
                this.$json("/dic/catagory/1","GET",{}).then(res=>{
                    this.major = res.data;
				});
            },
            changeClassify(r) {             //点击修改视频分类查询条件
                this.$nextTick(function () {
                    this.routers.forEach(t=> {
                        this.$set(t, 'active', false);
                    });
                    this.$set(r, 'active', true);
                });
                this.searchInfo.andModel.isPay = r.entrance==="true";
                this.searchInfo.pageObject.currentPage=1;
                this.getResource(this.searchInfo);
            },
            //点击资源上传
            uploadResource() {
                this.$store.dispatch('setUploadVisible',true);
                Utils.$emit('clearForm');
            },
            changeType(val){
                this.form.dicId='';
                this.getDicNameByCode(val);
            },
            changeCurrent(data){
                this.searchInfo.pageObject.currentPage=data;
                this.getResource(this.searchInfo);
            },
            handleChange(file, fileList) {
                this.fileList = fileList;
                let name = file.name;
                let index = name.lastIndexOf(".");
                this.form.resourceName=name.substring(0,index);
            },
			//菜单选择章节
            chooseCatalog(c){
                this.$nextTick(function(){
                    this.major.forEach((category)=>{
                        this.$set(category,"active",false);
                        category.childList.forEach(c=>{
                            this.$set(c,"active",false);
                        })
                    });
                });
                //选择的是全部
                if(c===undefined){
                    this.$refs.all.classList.add("font-active");
                    delete this.searchInfo.andModel.catagoryId;
                    this.category=[];
                    this.getResource(this.searchInfo);
				}
                else{
                    this.$refs.all.classList.remove("font-active");
                    this.$nextTick(function(){
                        this.major.forEach((major)=>{
                            this.$set(major,"active",false);
                        });
                        this.$set(c,"active",true);
                    });
					this.category = c.childList;
                }
			},
            changeCategory(c){
                this.$nextTick(function(){
                    this.category.forEach((category)=>{
						this.$set(category,"active",false);
					});
                    this.$set(c,"active",true);
				});
                this.searchInfo.andModel.catagoryId = c.id;
                this.searchInfo.andModel.orLike="";
                //重置分页
                this.searchInfo.pageObject.currentPage=1;
                this.getResource(this.searchInfo);
			}
        },
        watch:{
        }
    }
</script>

<style scoped lang="less">
	//@import "../assets/css/tabs";

    .dialog-form{
        width:520px;
        margin:0 auto;
        padding:0 0 20px 60px;
        border-bottom:1px solid #ddd;
    }
    .dialog-footer{
        text-align: center;
	}


	.classify-box{
		font-size:14px;
		margin:10px 0;
		&>.fl{
			width:80px;
		}
		.tags{
			width:calc(100% - 80px);
			&>span{
				display: inline-block;
				width:40px;
			}
			&>div{
				width:100%;
			}
		}
	}

    .second-box{
        &>ul{
            &>li{
                position: relative;
				min-width:60px;
				text-align: center;
				margin:0 10px 5px;
				cursor: pointer;
				display: inline-block;
            }
        }
    }

	.font-active{
		color:#0cf;
	}
</style>
